import type { ToggleButtonProps } from '@mui/material';
import MuIToggleButton from '@mui/material/ToggleButton';
import { forwardRef } from 'react';

const ToggleButton = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  (props, ref) => {
    return <MuIToggleButton ref={ref} {...props} />;
  },
);
ToggleButton.displayName = 'ToggleButton';
export default ToggleButton;
